/// <reference path="../../_ext/editors/BOMEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationIssueItemsGrid extends Serenity.EntityGrid<CertificationIssueItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.CertificationIssueItems'; }
        protected getDialogType() { return CertificationIssueItemsDialog; }
        protected getIdProperty() { return CertificationIssueItemsRow.idProperty; }
        protected getInsertPermission() { return CertificationIssueItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationIssueItemsRow.localTextPrefix; }
        protected getService() { return CertificationIssueItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}